export default __webpack_public_path__ + "static/media/ic_usdc_40.38f03c0f.svg";